module.exports = __webpack_public_path__ + "assets/media/lunch.675c1e37.mp3";